module.exports = __webpack_public_path__ + "icon_authorize_gray.b4ddc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_authorize_gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_authorize_gray.svg
// module chunks = main